import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import VeiculoService from "service/gestao/frotas/VeiculoService";
import { IdMatchModeOptions, NumberMatchModeOptions, TextMatchModeOptions, filterApplyTemplate, numberFilterTemplate } from "utils/filterUtils";

const veiculoService = new VeiculoService();

export default function VeiculoListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Veículos');
    const [marcas, setMarcas] = useState<any[]>([]);

    useEffect(() => {
        veiculoService.marcasDisponiveis().then(data => setMarcas(data)).catch(erro => console.log(erro));
    }, [])

    const defaultFilters: DataTableFilterMeta = {
        identificador: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        marca: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        modelo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        placa: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        quilometragem: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
                }
            ],
            operator: FilterOperator.AND
        },
        horimetro: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
                }
            ],
            operator: FilterOperator.AND
        },
        chassi: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const marcaFilterField = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={marcas} filter
            onChange={(e) => options.filterCallback(e.value)} 
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    return (

        <BaseListagem ordenacao="modelo,ASC" service={veiculoService} urlService="/veiculo" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="veiculo" >
            <Column field="identificador" header="Identificador" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="marca.nome" header="Marca" filter filterField="marca" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={marcaFilterField} />
            <Column field="modelo" header="Modelo" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="placa" header="Placa" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="quilometragem" header="Quilometragem" 
                filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} filterElement={numberFilterTemplate}/>
            <Column field="horimetro" header="Horimetro" 
                filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} filterElement={numberFilterTemplate}/>
            <Column field="chassi" header="Chassi" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
        </BaseListagem>
    )
}